import script from "./CollapsibleItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleItem.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleItem.vue?vue&type=style&index=0&id=38b97354&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b97354"]])

export default __exports__